export default __webpack_public_path__ + "static/media/socialgalactic.841278c3.png";